import { render, staticRenderFns } from "./xfsPrivacyPolicy.vue?vue&type=template&id=4496e6d4&scoped=true"
import script from "./xfsPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./xfsPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./xfsPrivacyPolicy.vue?vue&type=style&index=0&id=4496e6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496e6d4",
  null
  
)

export default component.exports